export default "__VITE_ASSET__98a9b0d4__"